import { useEffect, useState } from 'react';

const links = [
  { href: '#home', label: '首页' },
  { href: '#features', label: '核心玩法' },
  { href: '#hot', label: '一起看专区' },
  { href: '#categories', label: '主题分类' },
  { href: '#reviews', label: '漫友口碑' },
  { href: '#faq', label: '常见问题' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const goTo = (href: string) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'border-b border-background-200/70 bg-background-50/85 backdrop-blur-xl'
          : 'bg-transparent'
      }`}
    >
      <nav className="container-site flex h-16 items-center justify-between md:h-[72px]">
        <a
          href="#home"
          onClick={(e) => {
            e.preventDefault();
            goTo('#home');
          }}
          className="flex items-center gap-2.5"
          aria-label="178漫画网首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-book-open-fill text-lg"></i>
          </span>
          <span className="font-heading text-2xl tracking-wide text-foreground-950">
            178<span className="text-primary-400">漫画网</span>
          </span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => {
                e.preventDefault();
                goTo(l.href);
              }}
              className="rounded-full px-4 py-2 text-sm text-foreground-600 transition-colors hover:bg-background-200/60 hover:text-foreground-950 cursor-pointer"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <button
            type="button"
            className="btn-ghost !py-2 !text-xs"
            onClick={() => goTo('#hot')}
          >
            漫友同看
          </button>
          <button type="button" className="btn-primary !py-2 !text-xs" onClick={() => goTo('#hot')}>
            <i className="ri-play-circle-fill text-base"></i>
            开始同看
          </button>
        </div>

        <button
          type="button"
          className="flex h-10 w-10 items-center justify-center rounded-lg text-xl text-foreground-900 hover:bg-background-200/60 md:hidden cursor-pointer"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
        >
          <i className={open ? 'ri-close-line' : 'ri-menu-line'}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50/95 px-4 pb-6 pt-2 backdrop-blur-xl md:hidden">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => {
                  e.preventDefault();
                  goTo(l.href);
                }}
                className="rounded-xl px-4 py-3 text-sm text-foreground-700 hover:bg-background-200/60 cursor-pointer"
              >
                {l.label}
              </a>
            ))}
          </div>
          <button
            type="button"
            className="btn-primary mt-4 w-full"
            onClick={() => goTo('#hot')}
          >
            <i className="ri-play-circle-fill"></i>
            开始同看
          </button>
        </div>
      )}
    </header>
  );
}